<template>
      <section>

            <nav id="navbar" class="thematicMenuBar button-group thematics" v-on:click="isCategorySelected = true">
                  <router-link :to="'/' + category.code" v-for="category in categories" :key="category.id" v-bind:class="{'abc':$route.params.category_code === category.code}" v-scroll-to="'#navbar'">
                    {{ category.name }}
                  </router-link>
            </nav>

            <article id="category">
                <div v-if="!isCategorySelected" class="category-menu">
                    <carrousel @navigate="navigate"></carrousel>
                </div>
                <div class="mobile-info-div">
                    <p style="margin: auto;"><strong>Application mobile disponible, <a href="/about#info-mobile" target="_blank">plus d'infos ici</a> !</strong></p>
                </div>
                <h1 v-if="!isCategorySelected" id="allVideo">Toutes nos vidéos</h1>
                <app-videos v-if="!isCategorySelected" v-bind:videos="videos"></app-videos>
                <router-view></router-view>
            </article>
      </section>
</template>

<script>
  import CategoriesService from '../services/categories.js'
  import VideosService from '../services/videos.js'

  import VideosList from '@/components/VideosList'
  import Carrousel from '@/components/Carrousel.vue'

  export default {
    name: 'categories-list',
    components: {
      'app-videos': VideosList,
      'carrousel': Carrousel,
    },
    data: function () {
      return {
        categories: null,
        videos: null,
        isCategorySelected: null,
      }
    },
    created: function () {
      this.isCategorySelected = !!this.$route.params.category_code
      this.getCategoriesList()
      this.getVideosList()
    },
    beforeRouteUpdate: function (to, from, next) {
      if (from.name === 'category' && to.name === 'index') {
        this.isCategorySelected = false
      }
      next()
    },
    watch: {
      'isCategorySelected': function () {
        if (!this.isCategorySelected) {
          this.getCategoriesList()
          this.getVideosList()
        }
      }
    },
    methods: {

      getCategoriesList: function () {
        CategoriesService.get().then((res) => {
          console.log(res)
          this.categories = res.body
        }, (res) => {
          console.warn("get categories fail")
          console.warn(res)
        })
      },
      getVideosList: function () {
        VideosService.get().then((res) => {
          console.log('VideosService.get.then', this, res)
          this.videos = res.body
        }, (res) => {
          console.warn(res)
        })
      },
      navigate: function(target) {
        this.$router.push(target.path);
        this.isCategorySelected = target.isCategory;
      }
    },
  }
</script>

<style>
  #category {
    width: 100%;
  }

  .mobile-info-div {
      display: flex;
      justify-content: center;
      font-size: 1.25em;
  }

  .thematicMenuBar {
    background-color: white;
    color: black;
    font-weight: bolder;
    flex-direction: row;
    justify-content: space-between;
    display: table;
    width: 100%;
    position: relative;
    z-index: 2;
  }

  .thematicMenuBar a {
    max-width: 25%;
    min-width: 12%;
    display: table-cell;
    text-align: center;
    vertical-align: middle;

    padding-left: 3px;
    padding-right: 3px;
    padding-top: 10px;
    padding-bottom: 10px;
    margin: 0px;
    border: none;
    flex-grow: 1;

    background-color: rgba(0, 0, 0, 0);
    font-family: 'quicksandbold', Arial, sans-serif;
    font-size: 1.1em;
    text-decoration: none;
    color: black;
    cursor: pointer;
  }

  .thematicMenuBar a:nth-child(1):hover,
  .thematicMenuBar a:nth-child(1).router-link-active {
    background-color: #103479;
  }

  .thematicMenuBar a:nth-child(2):hover,
  .thematicMenuBar a:nth-child(2).router-link-active {
    background-color: #05458A;
  }

  .thematicMenuBar a:nth-child(3):hover,
  .thematicMenuBar a:nth-child(3).router-link-active {
    background-color: #00579b;
  }

  .thematicMenuBar a:nth-child(4):hover,
  .thematicMenuBar a:nth-child(4).router-link-active {
    background-color: #0065AB;
  }

  .thematicMenuBar a:nth-child(5):hover,
  .thematicMenuBar a:nth-child(5).router-link-active {
    background-color: #0073bc;
  }

  .thematicMenuBar a:nth-child(6):hover,
  .thematicMenuBar a:nth-child(6).router-link-active {
    background-color: #0089cF;
  }

  .thematicMenuBar a:nth-child(7):hover,
  .thematicMenuBar a:nth-child(7).router-link-active {
    background-color: #009fe3;
  }

  .thematicMenuBar a:hover,
  a.router-link-active {
    color: white;
  }

  .router-link-active {
    color: white;
  }

  .thematicMenuBar a:active {
    background-color: #8ad4f4;
  }

  .category-menu {
    min-height: 300px;
    margin-bottom: 30px;
    position: relative;
  }

  .category-menu .triangleImage {
    display: block;
    position: absolute;
    left: -6%;
    height: 565px;
    width: 800px;
    z-index: -1;
    background: url("~/static/img/back.jpg") -420px 0px no-repeat;
    background-color: grey;
  }

  .category-menu .triangleImage:before {
    width: 50%;
    height: 600px;
    display: block;
    position: absolute;
    content: "";
    top: 0px;
    left: 420px;
    z-index: 2;
    background-color: white;
  }

  .category-menu .triangleImage:after {
    width: 50%;
    height: 0px;
    border-top: 280px solid white;
    border-left: 420px solid transparent;
    border-bottom: 285px solid white;
    content: "";
    display: block;
    position: absolute;
    top: 0px;
    left: 0px;
    z-index: 1;
    margin: 0px;
    padding: 0px;
  }

  #category h2 {
    margin-left: 10%;
  }
  #allVideo:after
  {
    position: relative;
    right:2215px;
    bottom:1216px;
  }
</style>



// WEBPACK FOOTER //
// CategoriesList.vue?3ec971cc